import { z } from 'zod';

export const createEnumArraySchema = <T extends Record<string, string>>(
	enumObj: T,
) => z.array(z.enum(enumObj)).optional().prefault([]);
